import { formatDateTime } from "../../../../common/helpers/time";

function InstructorsViewTimeOffRequestsViewController(
  $stateParams,
  UserService,
  UsersModel,
  TimeoffRequestsModel,
) {
  const vm = this;
  vm.request = {};

  init();

  function init() {
    UsersModel.getInstructorByID(UserService.getCurrentUser().id).then(
      function (response) {
        vm.instructor = response;
      },
    );

    TimeoffRequestsModel.getRequestByID($stateParams.timeOffRequestId).then(
      function (response) {
        vm.request = {
          id: response.id,
          user_id: response.user_id,
          begin: formatDateTime(new Date(response.begin), "MM/DD/YYYY h:mm A"),
          end: formatDateTime(new Date(response.end), "MM/DD/YYYY h:mm A"),
          status: response.status,
          reason: response.reason,
          notes: response.notes,
        };
      },
    );
  }
}
InstructorsViewTimeOffRequestsViewController.$inject = [
  "$stateParams",
  "UserService",
  "UsersModel",
  "TimeoffRequestsModel",
];
export default InstructorsViewTimeOffRequestsViewController;

